"use client";

import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import {
  OpeningMonthData,
  OpeningMonthForm,
  useSchema,
} from "@faire/retailer-visitor-shared/views/SignUp/opening-month/__internal__/OpeningMonthForm";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Formik } from "formik";
import React from "react";

export const OpeningMonthStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.OPENING_MONTH
  );
  const [{ reported_creation_time, store_opening_month }] = useSignUpRequest([
    "store_opening_month",
    "reported_creation_time",
  ]);
  const schema = useSchema();

  const getHeaderText = () => {
    if (reported_creation_time === "OPENING_SOON") {
      return strictLocalize({
        defaultMessage: "What month will your store open?",
        description: {
          text: "Ask user when they plan on opening their business",
          img: "https://cdn.faire.com/fastly/679ced43fbddf3b4d2f1b93321ea2d3de0a86dc4215e66080afba00f6bb14ffd.png",
        },
      });
    }
    return strictLocalize({
      defaultMessage: "What month did your store open?",
      description: {
        text: "Asking the retailer to provide the month of the year that they opened their store",
        img: "https://cdn.faire.com/fastly/6be361f8dc8add9ae75e966465e05a8e57dbf32f213d7ff4499b9fd0f1d046bd.png",
      },
    });
  };

  const onNext = async (values: OpeningMonthData) => {
    saveAndGoToNextStep(values);
  };

  return (
    <SignupFormContainer>
      <SignUpTitle title={getHeaderText()} />
      <Spacer height="3x" />
      <Formik
        initialValues={{ store_opening_month }}
        validationSchema={schema}
        onSubmit={onNext}
      >
        <OpeningMonthForm />
      </Formik>
    </SignupFormContainer>
  );
};
